export default "__VITE_PUBLIC_ASSET__687f0520__"